/** @jsx jsx */
import { jsx } from '@emotion/react';
import {Tab, Tabs} from "@blueprintjs/core";
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { PropertyListSelector } from 'components/selectors/propertyListSelector';
import { BooleanSelector } from 'components/selectors/booleanSelector';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */
export const WorldMapKnobs = ({
	cardIndex,
	endpointQuery,
	widgetConfiguration = {},
}) => {
	return (
		<Tabs>
			<Tab id="data" title="Data" panel={
				<React.Fragment>
					<PropertyListSelector
						cardIndex={cardIndex}
						itemIndex={0}
						flags={[SrsPropertyFlag.Categorical]}
						label={'Count By'}
						endpointQuery={endpointQuery}
						cy-test="count-by-dropdown-button"
					/>
				</React.Fragment>
			} />
			<Tab id="style" title="Style" panel={
				<React.Fragment>
					<BooleanSelector
						cardIndex={cardIndex}
						widgetConfiguration={widgetConfiguration}
						label="Legend"
						propertyName="showLegend"
						cy-test="legend-checkbox"
					/>
				</React.Fragment>
			} />
		</Tabs>
	);
};
